import { GraduationCap, Target, Heart, Lightbulb } from "lucide-react";

const values = [
  { icon: Target, t: "Job-First Curriculum", d: "Every topic maps to a real interview question or on-the-job task." },
  { icon: Heart, t: "Affordable for All", d: "We remove money as a barrier to career rooting — talk to our counsellor about transparent, student-friendly fees." },
  { icon: Lightbulb, t: "Industry Trainers", d: "Classes are taught by working biomedical engineers, not generic faculty." },
  { icon: GraduationCap, t: "Recorded Sessions", d: "Re-watch every class during the program. Never miss a topic." },
];

export const About = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="about-page">
    <span className="eyebrow">About BIOMAC</span>
    <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-semibold text-[#0A3B32] tracking-tight max-w-4xl">
      Built for graduates who want a real career, not just a certificate.
    </h1>
    <p className="mt-6 text-lg text-slate-600 max-w-3xl leading-relaxed">
      BIOMAC is a specialised coaching center for the medical devices industry. We help
      graduates and diploma students from any stream — B.Sc, B.E., B.Tech, B.Pharm, BPT,
      Diploma — step into well-paying roles across hospitals, biomedical OEMs and device
      distributors.
    </p>

    <div className="mt-16 grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-6">
        <img
          src="https://images.pexels.com/photos/37492297/pexels-photo-37492297.jpeg"
          alt="Service engineer performing maintenance on a fully-automatic laboratory analyzer"
          className="rounded-2xl w-full h-[460px] object-cover"
        />
      </div>
      <div className="lg:col-span-6">
        <h2 className="font-heading text-3xl font-semibold text-[#0A3B32]">Our Mission</h2>
        <p className="mt-4 text-slate-600 leading-relaxed">
          India needs over 50,000 biomedical professionals every year, yet most graduates have
          no idea what the industry actually does. BIOMAC bridges this gap with a focused
          45-day program that demystifies medical devices, hospitals, and the career options
          that exist within them.
        </p>
        <p className="mt-4 text-slate-600 leading-relaxed">
          We believe job-oriented education should be accessible to every student, regardless
          of their family income. That's why we've kept BIOMAC's fees transparent and student-friendly — our counsellor will walk you through the current batch's pricing when you reserve a seat.
        </p>
      </div>
    </div>

    <div className="mt-20">
      <h2 className="font-heading text-3xl font-semibold text-[#0A3B32]">What we stand for</h2>
      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {values.map((v, i) => (
          <div key={v.t} className="card-soft" data-testid={`value-${i}`}>
            <div className="w-12 h-12 rounded-xl bg-[#0A3B32]/10 text-[#0A3B32] flex items-center justify-center mb-5">
              <v.icon strokeWidth={1.6} />
            </div>
            <h3 className="font-heading text-lg font-semibold text-[#0A3B32]">{v.t}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{v.d}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);
